// import React from 'react'
// import CutHome from './CutHome'
// import NumberCut from './NumberCut'
// import GamePageCss from '../css/GamePageCss'
// import NumberModal from './NumberModal'
// import WinningModal from './WinningModal'
// export default function CutPage() {
//     return (
//         <>
//             <GamePageCss>
//                 <CutHome />
//                 <div className="midPart">
//                     <NumberCut />
//                     {/* <History /> */}
//                 </div>
//                 <NumberModal />
//                 <WinningModal />
//             </GamePageCss>
//         </>
//     )
// }


import React from 'react'
import CutHome from './CutHome'
import NumberCut from './NumberCut'
import GamePageCss from '../css/GamePageCss'
import NumberModal from './NumberModal'
import WinningModal from './WinningModal'
import { Helmet } from 'react-helmet'

export default function CutPage() {
    return (
        <>
            <Helmet>
                {/* Page Title */}
                <title>Cutting Results | Copy & Forward Market Updates | Matka Jantri</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="View and copy the latest cutting results to forward to the market. Stay updated with real-time Matka cutting data on MatkaJantri."
                />

                {/* SEO Directives */}
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://pushpabetfair.com/cutpage" />

                {/* Favicon and Icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph */}
                <meta property="og:title" content="Cutting Results | Copy & Forward Market Updates | MatkaJantri" />
                <meta
                    property="og:description"
                    content="View and copy the latest cutting results to forward to the market. Stay updated with real-time Matka cutting data on MatkaJantri."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://pushpabetfair.com/cutpage" />
                <meta property="og:image" content="https://app.matkajantri.com/JantriImage/Logo.png" />

            </Helmet>

            <GamePageCss>
                <CutHome />
                <div className="midPart">
                    <NumberCut />
                    {/* <History /> */}
                </div>
                <NumberModal />
                <WinningModal />
            </GamePageCss>
        </>
    )
}
